import CheckIcon from '@/components/icons/CheckIcon';
import { FC } from 'react';
import styles from './style.module.css';

export type Size = 'small' | 'medium' | 'big';
export type Variant = 'primary' | 'secondary' | 'ghost';

export type CheckboxProps = {
  children?: React.ReactNode;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  onClick?: (event: { target: { checked: boolean } }) => void;
} & React.ButtonHTMLAttributes<HTMLInputElement>;

const Checkbox: FC<CheckboxProps> = ({
  value,
  checked = false,
  disabled = false,
  children,
  onClick,
  ...props
}) => {
  return (
    <div
      className={`${styles.wrapper} ${checked && styles.checked} ${
        disabled && styles.disabled
      } flex-row gap-s`}
      onClick={() => onClick && onClick({ target: { checked: !checked } })}
    >
      <div>
        <input
          type="checkbox"
          value={value}
          defaultChecked={checked}
          disabled={disabled}
          className={styles.checkbox}
        />
        <span
          className={`${styles.checkmark} ${checked && styles.checked} ${
            disabled && styles.disabled
          }`}
        >
          <CheckIcon
            className={`${styles.checkIcon} ${checked && styles.visible}`}
          />
        </span>
      </div>
      <div className={`${styles.checkboxLabel} ${disabled && styles.disabled}`}>
        {children}
      </div>
    </div>
  );
};

export default Checkbox;
